/** Returns true whether the specified object equals null either undefined */
export function isNullOrUndefined<T>(obj: T | null | undefined): obj is null | undefined {
  return typeof obj === 'undefined' || obj === null;
}

/** Returns true whether the specified object doesn't equal null neither */
export function isDefined<T>(obj: T): obj is Exclude<T, null | undefined> {
  return !isNullOrUndefined(obj);
}
